import { NgIf } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
    selector: 'svg-head',
    templateUrl: './svg-head.component.html',
    imports: [NgIf],
})
export class SvgHeadComponent implements AfterViewInit {
    @Input() url: string;
    worldIcon: any = '';
    ngAfterViewInit(): void {
        const symbolElement = document.getElementById('fallback-world-icon');
        this.worldIcon = symbolElement && symbolElement.innerHTML;
    }
}
